import { useEffect } from 'react';

import { useAuth } from '@/provider/UserProvider';
import { getTopCreator } from '@/services';
import type { UserProfile } from '@/types/user';
import { useSQuery } from '@/utils';

const useTopCreator = () => {
  const { isLogin } = useAuth();

  const { data, refetch } = useSQuery({
    queryKey: ['get-top-creator'],
    queryFn: () => getTopCreator({ size: 12, offset: 0 }),
    keepPreviousData: true,
  });

  useEffect(() => {
    refetch();
  }, [isLogin]);

  const list: UserProfile[] = data?.data?.items ?? [];

  return { list };
};

export default useTopCreator;
